// Vocals.js

import React from 'react'
import './Vocals.css';
import YunHeader from '../Common/YunHeader/YunHeader';
import YunSection from '../Common/YunSection/YunSection';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Switch from '@material-ui/core/Switch';

import {
    cppInstallAutoTunePlugin,
    cppUnInstallAutoTunePlugin,
    setWindowTitle,
    cppSetWindowIcon,
    cppAutoTunePluginPath,
    cppExploreFolder,
    cppCloseWindow,
    cppBroadcastWndMsg,
    cppInstallQQMusicAutoTunePlugin,
    cppUnInstallQQMusicAutoTunePlugin,
    cppQQMusicAutoTunePluginPath,
    cppInstallKwMusicPlugin,
    cppUnInstallKwMusicPlugin,
    cppKwMusicPluginPath,
    cppGetAppInfo,
    cppFixKugou,
    cppGetKugouAudioEffectStatus,
    cppSetKugouAudioEffectStatus,
} from '../../api/cpp'

import getProductInfo from '../../static/getProductInfo';

import {
    getVocalsModel,
    setVocalsModel,
    getKugouEffectTipDisable,
    setKugouEffectTipDisable,
} from '../App/local';
import { getPluginShowName } from '../App/tools';
import { compareVersions } from '../../utils/index';

const appInfo = cppGetAppInfo();
const isNewVersion395 = compareVersions(appInfo && appInfo.version, "3.9.5"); //为true表示3.9.5以上新版本 不包含3.9.5本身
const isNewVersion396 = compareVersions(appInfo && appInfo.version, "3.9.6"); //为true表示3.9.6以上新版本 不包含3.9.6本身

class Vocals extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pluginName: "消人声",
            addDia: false,
            removeDia: false,
            diaType: "kugou",
            diaText: "酷狗音乐播放器",
            vocalsPluginState: [],
            vocalsModel: getVocalsModel(),
            productInfo: {},
            // 酷狗内部效果是否启用
            kugouEffectEnable: false,
            // 酷狗效果提示框
            kugouEffectDiaShow: true,
            // 操作提示框
            kugouEffectHandleDia: false,
        };

        this.handleShowAddDia = this.handleShowAddDia.bind(this);
        this.handleShowRemoveDia = this.handleShowRemoveDia.bind(this);
        this.handleInstallPlugin = this.handleInstallPlugin.bind(this);
        this.handleUnInstallPlugin = this.handleUnInstallPlugin.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.clickToPluginDir = this.clickToPluginDir.bind(this);
        this.clickSetVocalsModel = this.clickSetVocalsModel.bind(this);
        this.initState = this.initState.bind(this);
        this.changeKugouEffectEnable = this.changeKugouEffectEnable.bind(this);
        this.changeKugouEffectDiaShow = this.changeKugouEffectDiaShow.bind(this);
        this.showKugouEffectHandleDia = this.showKugouEffectHandleDia.bind(this);
    }
    handleShowAddDia(type) {
        let text = "酷狗音乐播放器";
        if (type === "qq") {
            text = "QQ音乐播放器";
        } else if (type === "kuwo") {
            text = "酷我音乐播放器";
        }
        this.setState({
            addDia: true,
            diaType: type,
            diaText: text,
        })
    }
    handleShowRemoveDia(type) {
        let text = "酷狗音乐播放器";
        if (type === "qq") {
            text = "QQ音乐播放器";
        } else if (type === "kuwo") {
            text = "酷我音乐播放器";
        }
        this.setState({
            removeDia: true,
            diaType: type,
            diaText: text,
        })
    }

    // 安装插件
    handleInstallPlugin() {
        this.handleClose();
        if (this.state.diaType === "kugou") {
            cppInstallAutoTunePlugin(this.state.pluginName, true);
            cppInstallAutoTunePlugin("emFix", false);
            // 3.9.5及以下的版本执行一次修复酷狗的命令
            if (!isNewVersion395) {
                cppFixKugou();
            }
        } else if (this.state.diaType === "qq") {
            cppInstallQQMusicAutoTunePlugin(this.state.pluginName);
        } else if (this.state.diaType === "kuwo") {
            cppInstallKwMusicPlugin(this.state.pluginName);
        }
    }
    // 卸载插件
    handleUnInstallPlugin() {
        this.handleClose();
        if (this.state.diaType === "kugou") {
            cppUnInstallAutoTunePlugin(this.state.pluginName);
        } else if (this.state.diaType === "qq") {
            cppUnInstallQQMusicAutoTunePlugin(this.state.pluginName);
        } else if (this.state.diaType === "kuwo") {
            cppUnInstallKwMusicPlugin(this.state.pluginName);
        }
    }

    // 打开插件目录
    clickToPluginDir(type) {
        let pluginFile = "";
        if (type === "kugou") {
            pluginFile = cppAutoTunePluginPath(this.state.pluginName);
        } else if (type === "qq") {
            pluginFile = cppQQMusicAutoTunePluginPath(this.state.pluginName);
        } else if (type === "kuwo") {
            pluginFile = cppKwMusicPluginPath(this.state.pluginName);
        }
        if (pluginFile) {
            const dir = pluginFile.split('\\').slice(0, -1).join('\\')
            cppExploreFolder(dir)
        }
    }

    // 关闭弹框
    handleClose() {
        this.setState({
            addDia: false,
            removeDia: false,
            kugouEffectHandleDia: false,
        })
    }

    // 点击设置消人声模式
    clickSetVocalsModel(model) {
        if (model === this.state.vocalsModel) {
            return false
        }
        if (!['reset', 'renew', 'lock'].includes(model)) {
            model = 'reset'
        }
        this.setState({
            vocalsModel: model,
        })
        setVocalsModel(model);
        // 将当前状态通知到主页面
        cppBroadcastWndMsg('VocalsModel' + model);
    }
    // 初始化状态
    initState() {
        this.setState({
            vocalsModel: getVocalsModel(),
        })
    }

    // 设置酷狗内部音效启用
    showKugouEffectHandleDia() {
        this.setState({
            kugouEffectHandleDia: true
        })
    }
    changeKugouEffectEnable() {
        this.handleClose();
        const enable = !this.state.kugouEffectEnable
        this.setState({
            kugouEffectEnable: enable,
        })
        cppSetKugouAudioEffectStatus(enable);
    }
    // 设置酷狗音效提示框
    changeKugouEffectDiaShow() {
        const enable = !this.state.kugouEffectDiaShow
        this.setState({
            kugouEffectDiaShow: enable,
        })
        setKugouEffectTipDisable(!enable);
    }

   

    componentDidMount() {
        setWindowTitle('消人声&消伴奏设置');
        getProductInfo().then(productInfo => {
            this.setState({
                productInfo: productInfo,
            })
            cppSetWindowIcon(productInfo.WindowIconFileName);
        })

        if (isNewVersion396) {
            this.setState({
                kugouEffectEnable: cppGetKugouAudioEffectStatus(),
                kugouEffectDiaShow: !getKugouEffectTipDisable(),
            })
        }
        
        // 广播信息 同步插件状态
        setTimeout(() => {
            cppBroadcastWndMsg('Init_Plugin_State');
        }, 1000);

        // 监听别的页面的通知消息
        try {
            window.onRecvBroadcastWndMsg = (msg) => {
                if (msg === 'Login_In') {
                    // 回到登录页面时，关闭此页面
                    cppCloseWindow()
                }
                // 重置状态
                if (msg === 'Reload_State') {
                    this.initState();
                }
                if (msg && /^vocalsPluginStateInfo/.test(msg)) {
                    const vocalsPluginState = JSON.parse(msg.replace('vocalsPluginStateInfo', ''))
                    if (Array.isArray(vocalsPluginState)) {
                        this.setState({
                            vocalsPluginState: vocalsPluginState
                        })
                    }
                }
            }
        } catch (error) {
        }
        // 监听插件状态
        try {
            window.onPluginStatChange = (name, online) => {
                if (typeof name === "string" && name.includes(this.state.pluginName)) {
                    const vocalsPluginState = JSON.parse(JSON.stringify(this.state.vocalsPluginState))
                    if (online) {
                        vocalsPluginState.push(name)
                    } else {
                        const index = vocalsPluginState.indexOf(name);
                        if (index !== -1) {
                            vocalsPluginState.splice(index, 1);
                        }
                    }
                    this.setState({
                        vocalsPluginState: vocalsPluginState
                    })
                }
            }
        } catch (error) {
        }
    }

    render() {
        const vocalsPluginState = this.state.vocalsPluginState;
        const diaClassNameStr = isNewVersion396 ? "VocalsDia V396" : "VocalsDia"
        return (
            <div className="Vocals AppContainer">
                <YunHeader hideOnTop hideMin productInfo={this.state.productInfo} title="消人声&消伴奏"></YunHeader>
                {/* 原声消除插件状态 */}
                <YunSection className="SettingBox" width="200" height="60">
                    <div className="Flex">
                        <div className="Label">原声消除插件状态</div>
                        <p className="HoverColor MainColor">{vocalsPluginState.length ? '已连接' : '未连接'}</p>
                    </div>
                    <div>
                        <p className="Text">{getPluginShowName(vocalsPluginState[vocalsPluginState.length - 1])}</p>
                    </div>
                </YunSection>
                {/* 酷狗内部音效 */}
                {
                    isNewVersion396 && (
                        <YunSection className="SettingBox" width="200" height="60">
                            <div className="Flex">
                                <div className="Label">酷狗内部音效</div>
                                <p className="HoverColor MainColor">{this.state.kugouEffectEnable ? '已开启' : '未开启'}</p>
                            </div>
                            <div className="Flex">
                                <div className="Flex SwitchBox">
                                    <p>状态提醒</p>
                                    <Switch onChange={this.changeKugouEffectDiaShow} checked={this.state.kugouEffectDiaShow} className="Normal"  color="primary" />
                                </div>
                                <div className="YunBtn Large YellowColor" onClick={this.showKugouEffectHandleDia}>{this.state.kugouEffectEnable ? '关闭音效' : '开启音效'}</div>
                            </div>
                        </YunSection>
                    )
                }
                {/* 原声消除插件 */}
                <YunSection className="SettingBox Large" width="200" height="130">
                    <div className="Flex">
                        <div className="Label">原声消除插件</div>
                        <div onClick={() => this.clickToPluginDir("kugou")} className="YunBtn Large MainColor">X86 插件</div>
                    </div>
                    <div className="Flex">
                        <div><span className="KugouColor">酷狗</span>播放器</div>
                        <div className="Flex">
                            <div onClick={() => this.handleShowAddDia("kugou")} className="YunBtn Confirm Small RightGap">添 加</div>
                            <div onClick={() => this.handleShowRemoveDia("kugou")} className="YunBtn Small">移 除</div>
                        </div>
                    </div>
                    <div className="Flex">
                        <div><span className="KuwoColor">酷我</span>播放器</div>
                        <div className="Flex">
                            <div onClick={() => this.handleShowAddDia("kuwo")} className="YunBtn Confirm Small RightGap">添 加</div>
                            <div onClick={() => this.handleShowRemoveDia("kuwo")} className="YunBtn Small">移 除</div>
                        </div>
                    </div>
                    <div className="Flex">
                        <div><span className="QqColor">QQ音乐</span>播放器</div>
                        <div className="Flex">
                            <div onClick={() => this.handleShowAddDia("qq")} className="YunBtn Confirm Small RightGap">添 加</div>
                            <div onClick={() => this.handleShowRemoveDia("qq")} className="YunBtn Small">移 除</div>
                        </div>
                    </div>
                </YunSection>
                <YunSection className="SettingBox Between" width="200" height="131">
                    <div className="Label">
                        音乐消原声模式
                    </div>
                    <div className={this.state.vocalsModel === "reset" ? "ModelSelect Active" : "ModelSelect"}>
                        <div onClick={() => this.clickSetVocalsModel("reset")} className="YunBtn Large">自动重置</div>
                        <div className="CursorDefault">切歌消声值归零</div>
                    </div>
                    <div className={this.state.vocalsModel === "renew" ? "ModelSelect Active" : "ModelSelect"}>
                        <div onClick={() => this.clickSetVocalsModel("renew")} className="YunBtn Large">自动恢复</div>
                        <div className="CursorDefault">
                            <p className="">切歌消声值恢复</p>
                            <p className="MainColor">(之前您的设置值)</p>
                        </div>
                    </div>
                    <div className={this.state.vocalsModel === "lock" ? "ModelSelect Active" : "ModelSelect"}>
                        <div onClick={() => this.clickSetVocalsModel("lock")} className="YunBtn Large">锁定状态</div>
                        <div className="CursorDefault">保持消声值不变</div>
                    </div>
                </YunSection>
                <Dialog open={this.state.addDia} onClose={this.handleClose} className={diaClassNameStr}>
                    <DialogTitle>
                        提示
                    </DialogTitle>
                    <DialogContent>
                        添加消人声插件将会关闭你的{this.state.diaText}，是否继续？
                    </DialogContent>
                    <DialogActions>
                        <div className="YunBtn Small" onClick={this.handleClose}>取消</div>
                        <div className="YunBtn Small" onClick={this.handleInstallPlugin}>确认</div>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.removeDia} onClose={this.handleClose} className={diaClassNameStr}>
                    <DialogTitle>
                        提示
                    </DialogTitle>
                    <DialogContent>
                        移除消人声插件将会关闭你的{this.state.diaText}，是否继续？
                    </DialogContent>
                    <DialogActions>
                        <div className="YunBtn Small" onClick={this.handleClose}>取消</div>
                        <div className="YunBtn Small" onClick={this.handleUnInstallPlugin}>确认</div>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.kugouEffectHandleDia} onClose={this.handleClose} className={diaClassNameStr}>
                    <DialogTitle>
                        提示
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.kugouEffectEnable ?
                            "关闭酷狗内部音效将会关闭你的酷狗播放器，是否继续？"
                            :
                            "开启酷狗内部音效将会关闭你的酷狗播放器，并且消人声功能可能不生效，是否继续？"
                        }
                    </DialogContent>
                    <DialogActions>
                        <div className="YunBtn Small" onClick={this.handleClose}>取消</div>
                        <div className="YunBtn Small" onClick={this.changeKugouEffectEnable}>确认</div>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default Vocals;
